var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdminUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1459 25.8273C20.4901 27.5396 23.3848 28.5385 26.5036 28.5385C34.1315 28.5385 40.7728 21.9359 40.7728 14.2692C40.7728 6.40077 34.3721 0 26.5036 0C18.6351 0 12.2344 6.40077 12.2344 14.2692C12.2344 19.0188 14.5582 23.2385 18.1459 25.8273Z",
    fill: "#6045EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0569 27.625C35.775 30.7235 31.3515 32.6192 26.5 32.6192C21.6485 32.6192 17.225 30.7235 13.9431 27.625C5.64654 32.1096 0 40.8954 0 50.9654C0 52.0865 0.917308 53.0038 2.03846 53.0038H50.9615C52.0827 53.0038 53 52.0865 53 50.9654C53 40.8954 47.3535 32.1096 39.0569 27.625Z",
    fill: "#6045EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminUser);
export default __webpack_public_path__ + "static/media/admin-user.62fb0fa12a894e4962b627797157b00d.svg";
export { ForwardRef as ReactComponent };